import styled from "@emotion/styled";
import { Notification } from "components/UI";
import { AddPartnerModal } from "features/members";
import { Outlet } from "react-router-dom";
import {
  CreateBankAccountModal,
  CreateChartOfAccountModal,
  ErrorModal,
  Menu,
  RecordExpenseModal,
  RecordRevenueModal,
  SuccessModal,
  UpdateBankAccountModal
} from "../components";

const Container = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const FinancesLayout = () => {
  // const { isOnboardingComplete, isLoading, isError } =
  //   useFinanceOnboardingStatus();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (isLoading || isError) return;

  //   if (!isOnboardingComplete) {
  //     navigate("/finances/onboarding");
  //   }
  // }, [isLoading, isError, navigate, isOnboardingComplete]);

  return (
    <Container>
      <Notification />
      <SuccessModal />
      <ErrorModal />
      <RecordRevenueModal />
      <CreateBankAccountModal />
      <UpdateBankAccountModal />
      <RecordExpenseModal />
      <CreateChartOfAccountModal />
      <AddPartnerModal />
      <Menu />
      <Outlet />
    </Container>
  );
};
